
import Button from '../../../components/base/Button';

export default function HostToolkitSection() {
  return (
    <section className="py-24 bg-gradient-to-br from-blue-50 via-emerald-50 to-teal-50 relative overflow-hidden">
      {/* Vibrant background elements */}
      <div className="absolute inset-0">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-gradient-to-r from-blue-200/40 to-emerald-200/40 rounded-full blur-3xl"></div>
        <div className="absolute bottom-1/4 right-1/4 w-80 h-80 bg-gradient-to-r from-emerald-200/40 to-teal-200/40 rounded-full blur-3xl"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-64 h-64 bg-gradient-to-r from-blue-100/30 to-emerald-100/30 rounded-full blur-2xl"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-16">
          <div className="inline-flex items-center px-6 py-3 bg-gradient-to-r from-emerald-600 to-blue-600 text-white rounded-full text-sm font-semibold mb-8 shadow-lg">
            <i className="ri-tools-fill mr-2"></i>
            Digital Products
          </div>
          <h2 className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-slate-900 to-slate-700 bg-clip-text text-transparent mb-6">
            Host Toolkit
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto leading-relaxed mb-12">
            Professional digital products and templates designed to streamline your hosting operations, enhance guest experiences, and maximize your rental property success.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          <div className="group bg-white/80 backdrop-blur-sm rounded-xl p-8 hover:shadow-xl transition-all duration-500 transform hover:-translate-y-2 border border-white/50 hover:border-emerald-200 flex flex-col h-full shadow-lg hover:bg-white/90">
            <div className="text-center mb-6">
              <div className="w-16 h-16 bg-gradient-to-r from-emerald-500 to-blue-500 rounded-xl flex items-center justify-center mx-auto mb-4 shadow-lg group-hover:shadow-xl transition-all duration-300 transform group-hover:scale-110">
                <i className="ri-book-open-fill text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-2 group-hover:text-emerald-700 transition-colors duration-300">Welcome Guides</h3>
            </div>
            <p className="text-slate-600 leading-relaxed text-center flex-grow">Professional welcome guidebook templates that enhance guest experience and reduce support requests.</p>
          </div>

          <div className="group bg-white/80 backdrop-blur-sm rounded-xl p-8 hover:shadow-xl transition-all duration-500 transform hover:-translate-y-2 border border-white/50 hover:border-blue-200 flex flex-col h-full shadow-lg hover:bg-white/90">
            <div className="text-center mb-6">
              <div className="w-16 h-16 bg-gradient-to-r from-blue-500 to-teal-500 rounded-xl flex items-center justify-center mx-auto mb-4 shadow-lg group-hover:shadow-xl transition-all duration-300 transform group-hover:scale-110">
                <i className="ri-checkbox-circle-fill text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-2 group-hover:text-blue-700 transition-colors duration-300">Cleaning Checklists</h3>
            </div>
            <p className="text-slate-600 leading-relaxed text-center flex-grow">Comprehensive checklists to ensure consistent quality and smooth turnovers between guest stays.</p>
          </div>

          <div className="group bg-white/80 backdrop-blur-sm rounded-xl p-8 hover:shadow-xl transition-all duration-500 transform hover:-translate-y-2 border border-white/50 hover:border-teal-200 flex flex-col h-full shadow-lg hover:bg-white/90">
            <div className="text-center mb-6">
              <div className="w-16 h-16 bg-gradient-to-r from-teal-500 to-emerald-500 rounded-xl flex items-center justify-center mx-auto mb-4 shadow-lg group-hover:shadow-xl transition-all duration-300 transform group-hover:scale-110">
                <i className="ri-message-3-fill text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-2 group-hover:text-teal-700 transition-colors duration-300">Message Templates</h3>
            </div>
            <p className="text-slate-600 leading-relaxed text-center flex-grow">Pre-written automated messaging templates for seamless guest communication throughout their stay.</p>
          </div>

          <div className="group bg-white/80 backdrop-blur-sm rounded-xl p-8 hover:shadow-xl transition-all duration-500 transform hover:-translate-y-2 border border-white/50 hover:border-emerald-200 flex flex-col h-full shadow-lg hover:bg-white/90">
            <div className="text-center mb-6">
              <div className="w-16 h-16 bg-gradient-to-r from-emerald-500 to-blue-500 rounded-xl flex items-center justify-center mx-auto mb-4 shadow-lg group-hover:shadow-xl transition-all duration-300 transform group-hover:scale-110">
                <i className="ri-file-chart-fill text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-2 group-hover:text-emerald-700 transition-colors duration-300">Investment Guides</h3>
            </div>
            <p className="text-slate-600 leading-relaxed text-center flex-grow">Essential guides for understanding financing options and scaling your rental property portfolio.</p>
          </div>
        </div>
        
        {/* Enhanced CTA section with visual */}
        <div className="text-center">
          <div className="relative bg-white/90 backdrop-blur-sm rounded-2xl p-12 overflow-hidden shadow-2xl border border-white/50">
            {/* Background image */}
            <div 
              className="absolute inset-0 bg-cover bg-center opacity-20"
              style={{
                backgroundImage: `url('https://public.readdy.ai/ai/img_res/2ff3f08ae853694735c8ca8b8ae50934.jpg')`
              }}
            ></div>
            
            {/* Subtle background decoration */}
            <div className="absolute top-0 right-0 w-32 h-32 bg-blue-100/30 rounded-full blur-2xl"></div>
            <div className="absolute bottom-0 left-0 w-24 h-24 bg-emerald-100/30 rounded-full blur-2xl"></div>
            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-40 h-40 bg-teal-100/20 rounded-full blur-3xl"></div>
            
            <div className="relative z-10 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              {/* Left side - Content */}
              <div className="text-left lg:text-left">
                <div className="inline-flex items-center px-6 py-3 bg-emerald-100/80 backdrop-blur-sm text-emerald-800 rounded-full text-sm font-bold mb-6 shadow-lg border border-emerald-200/50">
                  <i className="ri-star-fill mr-2 text-emerald-600"></i>
                  PROFESSIONAL TOOLKIT
                </div>
                <h3 className="text-3xl lg:text-4xl font-bold text-slate-900 mb-6">Ready to Streamline Your Hosting?</h3>
                <p className="text-slate-700 mb-8 text-lg leading-relaxed">Discover our complete collection of digital products, templates, and guides designed to help you succeed as a host.</p>
                <Button size="lg" className="bg-gradient-to-r from-yellow-400 to-yellow-500 hover:from-yellow-500 hover:to-yellow-600 text-slate-800 font-bold shadow-xl transform hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer" onClick={() => window.REACT_APP_NAVIGATE('/hosting')}>
                  <i className="ri-tools-fill mr-2"></i>
                  Explore Host Toolkit
                </Button>
              </div>
              
              {/* Right side - Visual */}
              <div className="relative">
                <div className="relative bg-white/60 backdrop-blur-sm rounded-xl p-8 border border-white/50 shadow-lg">
                  <img 
                    src="https://readdy.ai/api/search-image?query=Professional%20digital%20hosting%20toolkit%20mockup%20showing%20welcome%20guide%20templates%2C%20cleaning%20checklists%2C%20message%20templates%20on%20tablet%20and%20laptop%20screens%2C%20modern%20clean%20design%2C%20bright%20professional%20workspace%2C%20organized%20digital%20products%20display%2C%20contemporary%20business%20tools%2C%20well-lit%20bright%20office%20environment%2C%20productivity%20dashboard%20interface&width=600&height=400&seq=toolkit-visual-1&orientation=landscape"
                    alt="Host Toolkit Preview"
                    className="w-full h-64 object-cover object-top rounded-lg shadow-lg"
                  />
                  <div className="absolute -top-4 -right-4 w-12 h-12 bg-yellow-400 rounded-full flex items-center justify-center shadow-lg">
                    <i className="ri-star-fill text-slate-800 text-xl"></i>
                  </div>
                  <div className="absolute -bottom-4 -left-4 w-16 h-16 bg-slate-800 rounded-full flex items-center justify-center shadow-lg">
                    <i className="ri-download-cloud-fill text-white text-2xl"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
